import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageFeedDialogComponent } from './message-feed-dialog.component';


@Injectable()
export class MessageFeedDialogService {

  constructor(private modalService: NgbModal) { }

  public open(
    btnOkText: string = 'Rögzít',
    btnCancelText: string = 'Vissza',
    dialogSize: 'sm'|'lg' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(MessageFeedDialogComponent, { size: dialogSize });
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

}